import { invariant } from '@epic-web/invariant'
import { useRouteLoaderData } from '@remix-run/react'
import { type RootLoaderData, type loader as rootLoader } from '#app/root.tsx'

/**
 * @returns the request info from the root loader
 */
export function useRequestInfo() {
	const data = useRouteLoaderData<typeof rootLoader>('root') as RootLoaderData
	invariant(data?.requestInfo, 'No requestInfo found in root loader')

	return data.requestInfo
}

/**
 * Like `useRequestInfo`, but returns `undefined` instead of throwing when no
 * root loader data is available — e.g. `root.tsx`'s `ErrorBoundary` renders
 * without loader data, and components mounted outside any route (isolated
 * embeds, some tests) have no 'root' route at all. Mirrors the
 * `useOptionalUser`/`useUser` split in `#app/utils/user.ts`. Still requires
 * *some* Remix data router to be present — `useRouteLoaderData` itself
 * throws with no router at all, optional or not.
 */
export function useOptionalRequestInfo() {
	const data = useRouteLoaderData<typeof rootLoader>('root') as
		| RootLoaderData
		| undefined
	return data?.requestInfo
}
